import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import Categories from '../Categories/Categories';
import Seo from '../../Seo/Seo';
import { webPageSchema, itemListSchema } from '../../Seo/jsonld';
import { getRouteSeo } from '../../Seo/routeSeo';

function MenuPage() {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const seo = getRouteSeo("/menu");

  // Read from the same Redux slice <Categories /> populates, so the ItemList
  // schema always describes exactly the categories rendered on the page.
  const categoryState = useSelector((state) => state.categories);
  const categories = (categoryState?.categories?.data?.categories || [])
    .filter((category) => category.idCategory !== 0)
    .filter((category) => category.title !== "Hot Meal");

  return (
    <>
      <main>
        <Seo
          jsonLd={[
            webPageSchema({
              title: seo?.title,
              description: seo?.description,
              url: "/menu",
            }),
            itemListSchema({
              name: "Kategorier af skolemad",
              url: "/menu",
              items: categories.map((category) => ({
                name: category.title,
                path: `/menubyCategory/${category.idCategory}`,
              })),
            }),
          ]}
        />
        <section className="page-info-sec">
          <div
            className="bg-fixed wow fadeIn"
            data-wow-delay="0.1s"
            style={{ background: 'url("/assets/img/page-info1.png")' }}
          />
          <div className="bg-fixed img-overlay wow fadeIn" data-wow-delay="0.2s" />
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-md-12">
                <div className="page-info-block wow fadeInUp" data-wow-delay="0.3s">
                  <h1>Menu</h1>
                  <div className="btm-line-2 text-center justify-content-center">
                    <span />
                    <span />
                  </div>
                  <p>
                  Vælg og planlæg nemt sunde, lækre måltider til dine børn.
Vores Mad Menu sikrer, at hver bid er nærende og børnevenlig, leveret direkte til dit barn.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Categories />
      </main>
    </>
  )
}

export default MenuPage;
